import { Grid, TextField } from "@mui/material";
import { t } from "i18next";
import SelectDomainOwner from "../../../../../components/SelectDomainOwner";

function DomainTableSearch({ setFormData, formData }) {
  const { search, userid } = formData;

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <Grid item md={3} xs={12} sx={{ mr: 1 }}>
        <TextField id="domain_name" label={t("domain.domain_address")} variant="outlined"
                   value={search} className="ltr-textfield" fullWidth InputLabelProps={{ shrink: true }}
                   onChange={(e) => handleChange("search", e.target.value)}
        />
      </Grid>

      <Grid item md={3} xs={12} sx={{ mr: 1 }}>
        <SelectDomainOwner
           value={userid}
           onChange={(e) => handleChange("userid", e.target.value)}
        />
      </Grid>
    </>
  );
}

export default DomainTableSearch;
